export const FLOW = {
  upgrade: 'upgrade',
  upgradePerUser: 'upgradePerUser',
  upsell: 'upsell',
  onlineScheduling: 'online-scheduling',
};

export default FLOW;
